import { apiClient } from '@/utils/api';

export interface ActivityType {
  id: string;
  name: string;
  code: string;
  description?: string;
  icon?: string;
  color?: string;
  isActive: boolean;
  isDefault: boolean;
  order: number;
  actionType?: 'file' | 'form' | null;
  moduleId?: string | null;
  _count?: { modules: number };
  createdAt: string;
  updatedAt: string;
}

export const activityTypeService = {
  async getActivityTypes(activeOnly: boolean = true) {
    const response = await apiClient.get(`activity-types`, {
      params: { activeOnly: activeOnly.toString() },
    });
    return response.data;
  },

  async createActivityType(data: Partial<ActivityType>) {
    const response = await apiClient.post(`activity-types`, data);
    return response.data;
  },

  async updateActivityType(id: string, data: Partial<ActivityType>) {
    const response = await apiClient.put(`activity-types/${id}`, data);
    return response.data;
  },

  async deleteActivityType(id: string, options?: { permanent?: boolean }) {
    const response = await apiClient.delete(`activity-types/${id}`, {
      params: options?.permanent ? { permanent: 'true' } : undefined,
    });
    return response.data;
  },

  async reorderActivityTypes(order: { id: string; order: number }[]) {
    const response = await apiClient.post(`activity-types/reorder`, { order });
    return response.data;
  },
};

